import { navigate } from "gatsby";
import React from "react";
import gif from "../../../images/Hexomatic_Translation.gif";
import { rightArrow } from "../../../images/svgIcons";
import Button from "../../button";

import "./styles.scss";

const credits = [
  "DeepL & Google Translate",
  "Google & Google Maps data",
  "Email enrichment",
  "Traffic analysis",
  "Residential proxies",
  "Amazon Data",
  "Crowdsourced tasks",
  "SEO backlink data"
];
const PremiumCredits = () => (
  <div className="row pricing-premium-credits mt-4">
    <div className="col-12 col-md-6">
      <h2 className="f_size_22 f_700 t_color3 l_height40 mb_10">
        Premium credit add-on
      </h2>
      <div>
        Tap into premium machine translation, find outbound leads, enrich leads
        with contact information or traffic analytics, access residential
        proxies and save time with crowdsourced human workers right inside your
        workflows. This add-on includes access to:
      </div>
      <div className="my-3 d-flex flex-wrap">
        {credits.map((item: string) => (
          <div className="credits">
            <span className="pr-1">{rightArrow}</span> {item}
          </div>
        ))}
      </div>
      <div className="d-flex my-3">
        <div className="mr-4">
          <div>Starting from just</div>
          <div className="f_size_24 l_height40">
            <sup style={{ fontSize: "14px" }}>$</sup>4
            <sup style={{ fontSize: "14px" }}>99</sup>/
            <span className="f_size_14">monthly</span>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <Button
            onClick={() => navigate("/premium-credits")}
            className="learn-more"
          >
            Learn more
          </Button>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-6 text-center">
      <img src={gif} alt="credits" />
    </div>
  </div>
);

export default PremiumCredits;
